<template>
  <div
    class="max-w-xl mx-auto"
    :class="{ 'load load--fill': isLoading }"
  >
    <div class="flex">
      <div class="w-1/3">
        <h3 v-text="'Roles'" />
        <ul class="list-reset ml-1">
          <li
            v-for="role in roles.data"
            :key="role.id"
          >
            <AppCheckboxInput
              :id="`role_${role.id}`"
              :value="role.id"
              :name="`role_${role.id}`"
              :model-value="allRoleAbilitiesAreSelected(role)"
              :label="role.attributes.title"
              @change="toggleRole(role)"
            />
          </li>
        </ul>
      </div>
      <div class="w-2/3 mb-6">
        <h3 v-text="'Abilities'" />
        <input
          v-model="query"
          style="margin-bottom: 0;"
          type="text"
          placeholder="Filter abilities"
        >
        <div class="flex">
          <div class="w-1/2">
            <ul class="list-reset">
              <li
                v-for="role in roles.data.slice(0,4)"
                :key="role.id"
              >
                {{ role.attributes.title }}
                <ul class="list-reset ml-1 mb-6">
                  <li
                    v-for="ability in filteredRoleAbilities(role)"
                    :key="ability.id"
                  >
                    <AppCheckboxInput
                      :id="`ability_${ability.id}`"
                      v-model="selectedAbilities"
                      :value="ability.id"
                      :name="`ability_${ability.id}`"
                      :label="ability.attributes.title"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="w-1/2">
            <ul class="list-reset">
              <li
                v-for="role in roles.data.slice(4, 10)"
                :key="role.id"
              >
                {{ role.attributes.title }}
                <ul class="list-reset ml-1 mb-6">
                  <li
                    v-for="ability in filteredRoleAbilities(role)"
                    :key="ability.id"
                  >
                    <AppCheckboxInput
                      :id="`ability_${ability.id}`"
                      v-model="selectedAbilities"
                      :value="ability.id"
                      :name="`ability_${ability.id}`"
                      :label="ability.attributes.title"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center mb-6">
      <input
        type="submit"
        class="btn"
        value="Assign Permissions"
        @click.prevent="save"
      >
    </div>
  </div>
</template>

<script type="text/babel">
import AppCheckboxInput from 'Base/Resources/assets/js/components/forms/inputs/AppCheckboxInput'

export default {
  name: 'MembershipAbilities',
  components: {
    AppCheckboxInput,
  },
  props: {
    membershipUuid: {
      type: String,
      required: false,
      default: '',
    },
    context: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      query: '',
      isLoading: false,
      roles: {
        data: [],
      },
      membershipAbilities: {
        data: [],
      },
      selectedRoles: [],
      selectedAbilities: [],
    }
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    filteredRoleAbilities(role) {
      return role.abilities.data.filter((ability) => {
        return ability.attributes.title.toLowerCase().includes(this.query.toLowerCase())
      })
    },
    save() {
      this.isLoading = true

      this.$api.active().post(`memberships/${this.membershipUuid}/abilities`, {
        ability_ids: this.selectedAbilities,
        role_ids: this.selectedRoles,
      }).then((response) => {
        if (response.data.status === 'failed') {
          this.$store.commit('baseAddNotification', {
            title: 'Error!',
            text: response.data.message,
            type: 'error',
            timeout: false,
          })
        } else {
          this.$emit('membershipAbilitiesHaveBeenAssigned')

          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Permissions assigned successfully',
          })
        }

        this.isLoading = false
      }).catch((errors) => {
        this.$store.commit('baseAddNotification', {
          title: 'Error!',
          text: errors.response.data.message,
          type: 'error',
          timeout: false,
        })

        this.isLoading = false
      })
    },
    allRoleAbilitiesAreSelected(role) {
      const allRoleAbilitiesAreSelected = _.difference(_.map(role.abilities.data, 'id'), this.selectedAbilities).length === 0
      const index = this.selectedRoles.indexOf(role.id)

      if (allRoleAbilitiesAreSelected) {
        if (index === -1) {
          this.selectedRoles.push(role.id)
        }
      } else {
        if (index > -1) {
          this.selectedRoles.splice(index, 1)
        }
      }

      return allRoleAbilitiesAreSelected
    },
    fetch() {
      this.$api.active().get('roles?include=abilities')
        .then((response) => {
          this.roles = response.data

          this.roles.data = this.roles.data.filter(role => role.attributes.name !== 'base-permissions')
        })

      if (this.membershipUuid) {
        this.$api.active().get(`memberships/${this.membershipUuid}/abilities`).then((response) => {
          this.membershipAbilities = response.data

          this.selectedAbilities = _.map(response.data.data, 'id')
        })
      }
    },
    toggleRole(role) {
      const roleIndex = this.selectedRoles.indexOf(role.id)

      if (roleIndex === -1) {
        this.selectedRoles.push(role.id)

        role.abilities.data.forEach((ability) => {
          if (this.selectedAbilities.indexOf(ability.id) === -1) {
            this.selectedAbilities.push(ability.id)
          }
        })
      } else {
        this.selectedRoles.splice(roleIndex, 1)

        role.abilities.data.forEach((ability) => {
          const index = this.selectedAbilities.indexOf(ability.id)

          if (index > -1) {
            this.selectedAbilities.splice(index, 1)
          }
        })
      }
    },
  },
}
</script>
